import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const ContributeButtonDevelopOffersCover = ({ notification }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl ? `لديك عرض تطوير جديد` : 'You have new development offer'
      }
    />
  )
}

export default ContributeButtonDevelopOffersCover
